__turbopack_context__.v({
  "className": "nanumsquareroundeditor_1944a5b4-module__2xSZRq__className",
  "variable": "nanumsquareroundeditor_1944a5b4-module__2xSZRq__variable",
});
